import { notification } from 'ant-design-vue';

// types - [success, info, warning, error]
const notificationWithIcon = (type = 'error', message = '', description = '') => {
  notification[type]({
    message,
    description,
  });
};

export default notificationWithIcon;
